/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Users_Credits_GrantedInputs */

const en_admin_users_credits_granted = /** @type {(inputs: Admin_Users_Credits_GrantedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits granted`)
};

/**
* | output |
* | --- |
* | "Credits granted" |
*
* @param {Admin_Users_Credits_GrantedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_users_credits_granted = /** @type {((inputs?: Admin_Users_Credits_GrantedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Users_Credits_GrantedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_users_credits_granted(inputs)
});
export { admin_users_credits_granted as "admin.users.credits_granted" }